<template>
  <div class="page-404-container">
    <div class="page-404-info">
      <p class="error-404-des">Sorry… you got lost.</p>
      <nuxt-link class="back-home-btn" to="/">
        <span>Back to Home </span>
        <img :src="require('@/assets/images/error/power_btn.png')" />
      </nuxt-link>
    </div>
  </div>
</template>

<script>
  export default {
    layout: 'notFound'
  }
</script>

<style lang="scss" scoped>
  .page-404-container {
    position: relative;
    height: 0;
    background-size: 100% auto;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    width: 100%;
    height: 100vh;
    background-size: 100% auto;
    background: url('@/assets/images/error/pc_404.jpg') no-repeat center;
    background-size: cover;
  }
  p {
    margin: 0;
  }
  .page-404-info {
    position: absolute;
    left: 10%;
    width: 80%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    top: calc(5780% / 81);
  }

  .error-404-des {
    font-size: 24px;
    line-height: 38px;
    color: #ffffff;
    text-align: center;
    width: 100%;
  }

  .back-home-btn {
    margin: 50px 0;
    cursor: pointer;
    border-radius: 20px;
    border: 1px solid #ffffff;
    color: #ffffff;
    text-decoration: none;
    box-sizing: border-box;
    padding: 0 15px;
    width: 170px;
    height: 40px;
    line-height: 40px;
    display: inline-block;
    position: relative;
    text-align: left;
    img {
      width: 18px;
      margin-left: 11px;
      position: absolute;
      top: 11px;
    }
  }
</style>
